import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './redux/store';
import { Provider } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { PersistGate } from 'redux-persist/integration/react';

// const primaryColor = '#B31F2E';
// const secondaryColor = '#1fb3a4';

const primaryColor = '#444444';
const secondaryColor = '#bf360c';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: primaryColor
    },
    secondary: {
      main: secondaryColor
    }
  },
  overrides: {
    MuiButton: {
      containedSecondary: {
        // fontWeight: 600,
        letterSpacing: 1,
        // fontSize: 12,
        color: '#FFFFFF'
      },
      outlined: {
        color: secondaryColor,
        borderColor: secondaryColor
      }
    },
    MuiChip: {
      outlined: {
        color: secondaryColor,
        borderColor: secondaryColor,
        borderWidth: 2,
      }
    }
  }
});

const { store, persistor } = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
